import React from "react";
import {Spin} from "antd";
import "./index.styles.scss";
import SchemaBlock1 from "./SVG/SchemaBlock1";
import SchemaBlock2 from "./SVG/SchemaBlock2";
import SchemaBlock3 from "./SVG/SchemaBlock3";
import SchemaBlock4 from "./SVG/SchemaBlock4";
import {useSearchParams} from "react-router-dom";

import {useUrlSearchParams} from "use-url-search-params";
import ApratmentModelSchema from "./SVG/ApratmentModelSchema";
import {useQuery} from "react-query";
import jwtAxios from "../../../auth/jwt-api";


export default function Schema() {
    const [searchParams, setSearchParams] = useUrlSearchParams({
        floor: null,
        block:null,

    });

    const { data: apartmentsRes } = useQuery(
        ["block-apartments", searchParams.block, searchParams.floor],
        () => jwtAxios.get("/apartment", {
            params: {
                block: searchParams.block,
                floor: searchParams.floor,
                limit: 100,
            },
        }),
        {
            enabled: !!searchParams.block && !!searchParams.floor,
        }
    );

    const apartments = apartmentsRes?.data?.data?.results?.rows || [];
  return (
    <div className="schema-container">
      <ApratmentModelSchema
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        // refetchFloor={refetchFloor}
      ></ApratmentModelSchema>
       {/*<h1 className="title">Sxema</h1>*/}

      <div className="filter-image">
        <div className="image">
          {/*{isLoading && <Spin className="loading"></Spin>}*/}
            {searchParams.block==='1' && <SchemaBlock1 searchParams={searchParams} setSearchParams={setSearchParams} apartments={apartments}/>}
            {searchParams.block==='2' && <SchemaBlock2 searchParams={searchParams} setSearchParams={setSearchParams} apartments={apartments}/>}
            {searchParams.block==='3' && <SchemaBlock3 searchParams={searchParams} setSearchParams={setSearchParams} apartments={apartments}/>}
            {searchParams.block==='4' && <SchemaBlock4 searchParams={searchParams} setSearchParams={setSearchParams} apartments={apartments}/>}
          {/*<SVG*/}
          {/*  apartments={apartments?.data}*/}
          {/*  onApartmentClick={onApartmentClick}*/}
          {/*></SVG>*/}
        </div>

        {/*<Filters*/}
        {/*  searchParams={searchParams}*/}
        {/*  setSearchParams={setSearchParams}*/}
        {/*/>*/}
      </div>
    </div>
  );
}
